var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlobe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.003 20C15.5245 19.9984 20 15.5219 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.521 4.47417 19.997 9.99448 20L10 20L10.003 20ZM7.93247 2.08166C4.69892 2.9236 2.24364 5.69385 1.86812 9.09091H5.50008C5.70391 6.57892 6.54465 4.16765 7.93247 2.08166ZM12.0675 2.08166C13.4554 4.16765 14.2961 6.57892 14.4999 9.09091H18.1319C17.7564 5.69385 15.3011 2.9236 12.0675 2.08166ZM12.6749 9.09091C12.4466 6.62439 11.5179 4.2745 10 2.31892C8.48211 4.2745 7.55345 6.62439 7.32508 9.09091H12.6749ZM7.32508 10.9091H12.6749C12.4466 13.3756 11.5179 15.7255 10 17.6811C8.48211 15.7255 7.55344 13.3756 7.32508 10.9091ZM5.50008 10.9091H1.86812C2.24364 14.3061 4.69891 17.0764 7.93246 17.9183C6.54464 15.8323 5.7039 13.4211 5.50008 10.9091ZM12.0675 17.9183C13.4554 15.8323 14.2961 13.4211 14.4999 10.9091H18.1319C17.7564 14.3061 15.3011 17.0764 12.0675 17.9183Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlobe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/globe.c87aa7498d6b26b9d1624bb3154e1437.svg";